import { OrderedMap } from 'immutable';
import * as actions from './actions';

const initialState = new OrderedMap();

export default function (state = initialState, action) {
  switch (action.type) {
    case actions.ADD: {
      return state.set(action.payload.id, action.payload);
    }

    case actions.REMOVE: {
      return state.delete(action.payload.id);
    }

    default:
      return state;
  }
}
